import React from "react";
import "./NavBack.scss";

export const NavBack = (props) => {
  const { onClick, isOffcanvasOpen = false } = props;

  return (
    <div className="navbar-back">
      <button className="navbar-back-button" aria-label="Back" onClick={onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.4995 15.8333L6.66618 9.99999L12.4995 4.16666" stroke="#1855B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Kembali
      </button>
    </div>
  );
}
